import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import './style.css'
import NRTCardStack from "../../../../../../../../components/_common/CardStack"
import NRTListItem from "../../../../../../../../components/_common/ListItem"
import NRTForumMessages from "../../../../../../../../components/_ead/ForumMessages"
import NRTBreadcrumb from "../../../../../../../../components/_common/Breadcrumb"
import EadRequests from "../../../../../../../../requests/ead-requests"
import MCEadInputLabel from "../../../../../../../../components/_ead/InputLabel"
import moment from "moment/moment"
import MCLoadingOverlay from "../../../../../../../../components/_minha-central/LoadingOverlay"

const SIMULATE_GET_FORUMS_ERROR = false
const SIMULATE_GET_TOPIC_MESSAGES_ERROR = false
const SIMULATE_SEND_MSG_ERROR = false


class EadTutorPage extends React.Component {

    state = {
        awaiting: true,
        activeCard: 0,
        selectedTopic: null,
        topics: [],
        messages: [],
        loadingChat: false
    }


    static getDerivedStateFromProps(nextProps, prevState) {

        const {match} = nextProps
        const {params} = match
        const topicId = params.tabParam1

        if (!topicId) {
            return {
                activeCard: 0,
                selectedTopic: null,
            }
        }

        const {topics} = prevState || []
        const topic = topics.filter((forum) => forum.code + '' === topicId + '')[0]

        if (!topic)
            return null

        return {
            activeCard: (!!topic ? 1 : 0),
            selectedTopic: topic,
        }
    }

    componentDidUpdate(prevProps, prevState, ss) {
        if (prevState.selectedTopic !== this.state.selectedTopic && !!this.state.selectedTopic) {
            this.goToMessages(this.state.selectedTopic)
        }
    }

    componentDidMount() {
        const filters = {
            prlCode: this.props.release.code
        }


        if (!this.props.context.isTeacher) {
            filters.prsCode = this.props.context.person.code
        }

        const req = SIMULATE_GET_FORUMS_ERROR ?
            Promise.reject('SIMULATE_GET_FORUMS_ERROR') :
            EadRequests.searchTutorTopics(filters)

        req
            .then(result => {
                if (!result.success) {
                    //erro
                    return null
                } else {
                    this.setState({topics: result.forumtopic})
                }

                this.setState({awaiting: false})

            })
            .catch(error => {
                this.onError(error, 'Ocorreu um erro inesperado.')

            })

    }


    onStepClicked = (step, index) => {

        switch (index) {
            case 0:
                return this.goToTutorHome()
        }

    }


    goToTutorHome = () => this.props.history.push(`/conta/curso/${this.props.accountId}/tutoria`)

    goToMessages = (topic) => {
        const req = SIMULATE_GET_TOPIC_MESSAGES_ERROR ?
            Promise.reject('SIMULATE_GET_TOPIC_MESSAGES_ERROR') :
            EadRequests
                .searchForumPosts({
                    ftpCode: topic.code,
                    orderByClause: "s.postDate"
                })

        this.setState({awaiting: true}, () => {
            req
                .then(result => {
                    if (!result.success) {
                        return this.onError(
                            'Erro na requisicao de get das msgs do topico',
                            'Ocorreu um erro ao carregar as mensagens do tópico.'
                        )
                    }


                    this.setState(
                        {
                            messages: result.forumpost,
                            awaiting: false,
                        },
                        () => this.props.history.push(`/conta/curso/${this.props.accountId}/tutoria/${topic.code}`)
                    )
                })
                .catch(error => {
                    return this.onError(
                        error,
                        'Ocorreu um erro ao carregar as mensagens do tópico.'
                    )
                })

        })


    }


    sendMessageToTopic = (message, file) => {
        this.setState({
            loadingChat: true
        })

        const {person} = this.props.context
        const topic = this.state.selectedTopic

        const req = SIMULATE_SEND_MSG_ERROR ?
            Promise.reject('SIMULATE_SEND_MSG_ERROR') :
            EadRequests.saveForumPost({
                forumTopicDTO: topic,
                personPostCode: person.code,
                personPostName: person.name,
                personTypesPost: person.types,
                fileUrl: file,
                postDate: moment(),
                post: message
            })


        req
            .then(result => {
                if (!result.success)
                    return this.onError('Erro ao postar mensagem', 'Ocorreu um erro ao enviar a mensagem.')


                this.setState(state => ({
                    messages: [
                        ...state.messages,
                        result
                    ],
                    loadingChat: false
                }))
            })
            .catch(error => {
                this.onError(error, 'Ocorreu um erro ao enviar a mensagem.')
            })


    }


    onError(error, message, data) {

        console.error(error)

        this.setState({awaiting: false})

        this.props.context.set({
            toastMessage: {
                type: 'error',
                content: message
            }
        })
        this.props.context.logError(error, data)
    }

    submit = async () => {

        const ftpTitle = this.state.values.topic
        const fomCode = this.state.selectedForum.code
        const prlCode = this.props.context.eadAccount.code
        const prsCodeCreation = this.props.context.person.code


        if (!ftpTitle) {
            console.log("invalido")
            return null
        }

        const forumTopicDTO = {
            prlCode: prlCode,
            prsCodeCreation: prsCodeCreation,
            ftpTitle: ftpTitle,
            fomCode: fomCode
        }

        const result = await EadRequests.saveForumTopic(forumTopicDTO)

        const success = result.success

        if (success) {
            const selectedForum = this.state.selectedForum
            const result = await EadRequests.searchForums({prlCode: this.props.release.code})

            this.setState({
                forums: result.forum,
                selectedForum: result.forum.filter(f => f.code === selectedForum.code)[0]
            })

            this.newTopicInput.setValue("")
            this.props.context.set({
                toastMessage: {
                    type: 'success',
                    content: "Tópico criado com sucesso!"
                }
            })
        } else {
            this.props.context.set({
                toastMessage: {
                    type: 'error',
                    content: "Ocorreu um erro ao criar tópico. Recarregue a página e tente novamente. Caso o erro persista, entre em contato conosco.",
                }
            })
        }
    }


    render() {

        const avatarDefault = 'http://blog.ramboll.com/fehmarnbelt/wp-content/themes/ramboll2/images/profile-img.jpg'

        const {
            topics,
            awaiting,
            selectedTopic,
            activeCard,
        } = this.state

        const schema = this.props.context.credentials.schema;

        // const instructorText = <Fragment>
        //     <div className="avatar" style={{
        //         backgroundImage: `url('${topic.personDTO.mainImageUrl || avatarDefault}')`,
        //         backgroundPosition: 'center'
        //     }}/>
        //     <span
        //         style={{marginLeft: '.4rem'}}> {topic.personDTO.name} - {topic.contentDTO.breadcrumb}/{topic.contentDTO.name} ({topic.lastPostUser ? 'Sim' : ''}) </span>
        // </Fragment>
        //
        // const studentText = <Fragment>
        //     <span style={{marginLeft: '.4rem'}}> {topic.contentDTO.breadcrumb}/{topic.contentDTO.name}  ({!topic.lastPostUser ? 'Sim' : ''}) </span>
        // </Fragment>

        const steps = [{code: 'initial', display: 'Tutorias'}]

        if (!!selectedTopic) {
            steps.push({
                code: selectedTopic.code,
                display:
                    this.props.context.person.type === 4 ?
                        `${selectedTopic.personDTO.name} - ${selectedTopic.contentDTO.breadcrumb}/${selectedTopic.contentDTO.name}` :
                        `${selectedTopic.contentDTO.breadcrumb}/${selectedTopic.contentDTO.name}`
            })
        }




        const isInstructor = this.props.context.person.types.split('|')
            .map(type=>Number(type))
            .filter(type=> type === 1 || type === 4 )
            .length > 0

        return (
            <div className={'nrt-ead-tutor'}>

                <MCLoadingOverlay show={awaiting}/>
                <MCEadInputLabel text={
                    <NRTBreadcrumb steps={steps}
                                   onStepClicked={this.onStepClicked}
                    />
                }/>

                {
                    schema !== 'rl' ? '' : <div><span style={{borderRadius: '3px', background: '#FFFFAA', padding: '3px', border: '1px solid gray', marginBottom: '10px'}}>Em caso de dúvidas, favor enviar e-mail para <b>koiti@rlassociados.com.br</b>.</span><br/><br/></div>
                }

                {
                    topics.length === 0 &&
                    <div>
                        <h3 style={{
                            textAlign: 'center',
                            opacity: .5
                        }}
                        >Não existem tutorias abertas no momento.
                        </h3>
                    </div>
                }
                <NRTCardStack activeCard={activeCard}>
                    <ul>
                        {
                            topics.sort((a, b) => a.code - b.code).map((topic) =>
                                <NRTListItem key={'topico' + topic.code}
                                             style={{
                                                 borderRight: 0,
                                                 borderLeft: 0
                                             }}
                                             onClick={() => this.goToMessages(topic)}>
                                    {
                                        isInstructor ?
                                            <Fragment>
                                                <div className="avatar" style={{
                                                    backgroundImage: `url('${topic.personDTO.mainImageUrl || avatarDefault}')`,
                                                    backgroundPosition: 'center'
                                                }}/>
                                                <span style={{marginLeft: '.4rem'}}> {topic.personDTO.name} - {topic.contentDTO.breadcrumb}/{topic.contentDTO.name} </span>
                                                {topic.lastPostUser ? <div className='badge'> Novas Mensagens</div> : null}
                                            </Fragment> : <Fragment>
                                                <span style={{marginLeft: '.4rem'}}> {topic.contentDTO.breadcrumb}/{topic.contentDTO.name} </span>
                                                {!topic.lastPostUser ? <div className='badge'> Novas Mensagens</div> : null}
                                            </Fragment>
                                    }
                                </NRTListItem>
                            )
                        }
                    </ul>

                    <NRTForumMessages onSendMessage={this.sendMessageToTopic}
                                      loadingChat={this.state.loadingChat}
                                      messages={this.state.messages}
                                      prsCode={this.props.context.person.code}
                                      upload
                                      context={this.props.context}
                                      release={this.props.release}
                    />

                </NRTCardStack>

            </div>
        )
    }

}

EadTutorPage.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    release: PropTypes.object.isRequired,
    context: PropTypes.object.isRequired,
}

EadTutorPage.defaultProps = {}


export default EadTutorPage



// WEBPACK FOOTER //
// ./src/_pages/Account/_pages/CourseList/_pages/Course/_partials/Tutoria/index.js